module.exports = __webpack_public_path__ + "static/home-aquarium-15fc948ff078ce14ff3a975121524e92.jpg";